import React from 'react';

import { atom } from 'recoil';

/* 施設名データ */

type Facility = {
  facilityId: string;
  facilityName: string;
};

const FacilityState = atom<Facility>({
  key: 'facilityState',
  default: {
    facilityId: '',
    facilityName: '',
  }
});

export { FacilityState };

export type { Facility };
